"use client"

export function MenuSkeleton() {
  return (
    <section
      className="w-full"
      aria-labelledby="menu-heading"
      itemScope
      itemType="https://schema.org/Menu"
    >
      <h2 id="menu-heading" className="sr-only">
        Thực đơn nhà hàng
      </h2>
      <meta itemProp="name" content="Thực đơn nhà hàng" />

      {/* Search bar skeleton */}
      <div className="h-10 sm:h-12 w-full bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-shimmer rounded-md mb-4" />

      {/* Sticky tab bar skeleton */}
      <div className="sticky top-14 sm:top-16 bg-white z-[5] border-b border-gray-100 pb-3">
        <div className="flex gap-3 sm:gap-4 py-3 overflow-x-auto">
          {Array.from({ length: 5 }).map((_, index) => (
            <div
              key={index}
              className="h-7 sm:h-8 w-20 sm:w-28 flex-shrink-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-shimmer rounded-md"
            />
          ))}
        </div>
      </div>

      {/* Menu sections and items */}
      <div className="flex flex-col gap-4 mt-4">
        <div className="flex gap-4">
          <div className="w-full">
            {Array.from({ length: 3 }).map((_, categoryIndex) => (
              <div key={categoryIndex} className="mb-8 sm:mb-10">
                {/* Section title skeleton */}
                <div className="mb-3 sm:mb-4 h-5 sm:h-6 w-36 sm:w-48 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-shimmer rounded-md" />
                {/* Menu items grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-2 gap-4">
                  {Array.from({ length: 6 }).map((_, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="flex flex-row border border-gray-300/50 rounded-2xl overflow-hidden w-full max-w-full group"
                    >
                      {/* Image skeleton */}
                      <div className="relative shrink-0 aspect-square size-36 rounded-2xl overflow-hidden bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-shimmer" />
                      {/* Content skeleton */}
                      <div className="flex flex-col p-3 flex-grow relative">
                        {/* Title skeleton */}
                        <div className="font-semibold text-[15px] h-5 w-32 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-shimmer rounded mb-2" />
                        {/* Description skeleton */}
                        <div className="text-sm h-4 w-36 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-shimmer rounded mb-2" />
                        {/* Stats skeletons */}
                        <div className="flex items-center gap-4 mt-2 text-xs">
                          <div className="h-3 w-10 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-shimmer rounded" />
                          <div className="h-3 w-16 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-shimmer rounded" />
                        </div>
                        {/* Price and controls skeleton */}
                        <div className="flex items-center justify-between mt-auto pt-2">
                          <div className="h-5 w-20 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-shimmer rounded" />
                          {/* Controls skeleton (circle) */}
                          <div className="absolute right-3 bottom-3">
                            <div className="size-8 rounded-full bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-shimmer" />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export function RelatedRestaurantsSkeleton() {
  return (
    <div className="mt-3">
      <div className="h-8 bg-gray-200 rounded-full w-48 mb-2 animate-shimmer"></div>
      <div className="h-0 overflow-hidden rounded-lg w-full"></div>
    </div>
  )
}
